var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.config.show,
          expression: "config.show"
        }
      ],
      staticClass: "modal flex",
      class: _vm.config.theme,
      staticStyle: { "animation-duration": ".5s" },
      style: {
        zIndex: _vm.zIndex,
        width: _vm.config.width,
        animationDuration: _vm.config.duration,
        "animation-duration": _vm.config.duration
      }
    },
    [
      _c("div", {
        staticClass: "modal-backdrop in show",
        on: { click: _vm.clickBack }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.config.show,
              expression: "config.show"
            }
          ],
          staticClass: "modal-dialog",
          staticStyle: { "animation-duration": ".5s" },
          style: { width: _vm.config.width }
        },
        [
          _vm._t("content", [
            _vm._t("header", [
              _c(
                "div",
                { staticClass: "modal-header" },
                [
                  _vm._t("title", [
                    _c("h4", { staticClass: "modal-title" }, [
                      _vm._v(_vm._s(_vm.config.title))
                    ])
                  ])
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [_vm._t("default")], 2),
            _vm._v(" "),
            _vm._t("footer", [
              _c(
                "div",
                { staticClass: "modal-footer" },
                [
                  _vm._t("buttons", [
                    _c(
                      "button",
                      {
                        staticClass: "btn m-green",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.close()
                          }
                        }
                      },
                      [_vm._v("关闭")]
                    )
                  ])
                ],
                2
              )
            ])
          ])
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }